import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgS3 = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		fill: "#e25444",
		d: "m20.16099,4.24307l-4.10317,7.81086l4.10317,7.81086l1.68082,-0.93928l0,-13.74315l-1.68082,-0.93928z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#7b1d13",
		fillRule: "evenodd",
		d: "m20.16099,4.2925l-8.20634,0.93928l-4.17733,6.87158l4.17733,6.87158l8.20634,0.93928l0,-15.62171z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#58150d",
		fillRule: "evenodd",
		d: "m3.6,4.24307l-1.33477,0.59323l0,14.43525l1.33477,0.59323l8.35465,-7.81086l-8.35465,-7.81086z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		fill: "#e25444",
		d: "m3.58205,4.2266l8.38367,2.32897l0,11.20542l-8.38367,2.10928l0,-15.64366z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#58150d",
		fillRule: "evenodd",
		d: "m11.97012,7.78598l-3.55977,-0.57128l3.55977,-4.04276l3.55097,4.04276l-3.55097,0.57128z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#58150d",
		fillRule: "evenodd",
		d: "m15.5211,7.2147l-3.55537,0.58003l-3.55537,-0.58003l0,-4.04276m3.55977,13.095l-3.55977,0.65918l3.55977,3.47148l3.55097,-3.47148l-3.55097,-0.65918z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#7b1d13",
		fillRule: "evenodd",
		d: "m11.95465,0.13989l-3.55938,1.87856l0,5.19076l3.57045,-1.00518l-0.01107,-6.06414zm0.01107,8.92039l-3.55537,0.38674l0,5.18275l3.55537,0.40676l0,-5.97624zm0,8.74465l-3.55537,-0.89148l0,5.095l3.55537,1.86062l0,-6.06414z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		fill: "#e25444",
		d: "m15.5211,16.91346l-3.55537,0.89172l0,6.06389l3.55537,-1.86062l0,-5.095zm-3.55537,-7.85317l3.55537,0.38674l0,5.18275l-3.55537,0.40676l0,-5.97624zm-0.01107,-8.92039l3.55938,1.87856l0,5.19076l-3.55938,-0.98872l0,-6.0806z"
	}));
});
export default SvgS3;
